export interface TitleProps {
    level: headingLevels;
    headingNumber?: number;
    [propName: string]: any;
    disableTabStaticData?: boolean;
}
export type headingLevels = 1 | 2 | 3 | 4 | 5 | 6;

export function Title({ level, children, headingNumber, disableTabStaticData }: TitleProps) {
    const tabIndex = disableTabStaticData ? -1 : 0;

    if (level === 1) {
        return (
            <h1
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    if (level === 2) {
        return (
            <h2
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    if (level === 3) {
        return (
            <h3
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    if (level === 4) {
        return (
            <h4
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    if (level === 5) {
        return (
            <h5
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    if (level === 6) {
        return (
            <h6
                className={`heading-${level}-${headingNumber}`}
                tabIndex={tabIndex}
                dangerouslySetInnerHTML={{ __html: children || '' }}
            />
        );
    }

    return null;
}
